module.exports = __webpack_public_path__ + "img/glamping_2.2595374c.jpg";